export default __webpack_public_path__ + "static/media/capital.12f3aef4.png";